// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3pjIl","insightsList":"newBusinessInsightsMenu_insightsList__27cn2","active":"newBusinessInsightsMenu_active__3baSJ"};